module.exports = __webpack_public_path__ + "static/media/loginpage_left_side_img.93ab8221.svg";